import { useAccountUrl as useBaseAccountUrl } from 'domain/shared/account';

const useAccountUrl = () => {
  const accountUrl = useBaseAccountUrl();
  const { getSingleEntityUrl } = accountUrl;

  return {
    ...accountUrl,
    getRelatedOpportunitiesUrl: (id: string) => `${getSingleEntityUrl(id)}/related-opportunities`,
    getRelatedContactsUrl: (id: string) => `${getSingleEntityUrl(id)}/related-contacts`,
    getAccountClientPortalUrl: (id: string) => `${getSingleEntityUrl(id)}/client-portal`,
  };
};

export default useAccountUrl;
